// extracted by mini-css-extract-plugin
export var es_section = "solution-module--es_section--NHWtc";
export var solution_content = "solution-module--solution_content--3Xf62";
export var solution_title = "solution-module--solution_title--CIK9+";
export var solution_img_wrapper = "solution-module--solution_img_wrapper--9oYO0";
export var text_cta_col = "solution-module--text_cta_col--oXf-C";
export var text_cta_wrapper = "solution-module--text_cta_wrapper--uPvDm";
export var solutionRow = "solution-module--solutionRow--lUclq";